import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const LOCAL_DATE_TIME_FORMATS = [
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD hh:mm A',
  'YYYY-MM-DD h:mm A',
  'MM/DD/YYYY HH:mm:ss',
  'MM/DD/YYYY HH:mm',
  'MM/DD/YYYY hh:mm A',
  'MM/DD/YYYY h:mm A'
];

export function convertLocalToUTC(date: string, startTime: string) {
  const localDateTime = new Date(dayjs(date).format('YYYY-MM-DD') + 'T' + startTime);
  const utcDateTime = localDateTime.toISOString();

  return utcDateTime;
}

export function getTimezoneOffsetHours(date?: string | null, time?: string | null) {
  if (!date || !time) {
    return undefined;
  }

  const localDateTime = dayjs(`${date} ${time}`, LOCAL_DATE_TIME_FORMATS, true);

  if (!localDateTime.isValid()) {
    return undefined;
  }

  return Math.floor(localDateTime.toDate().getTimezoneOffset() / 60);
}
